(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('MedDosageUnitSearch', MedDosageUnitSearch);

    MedDosageUnitSearch.$inject = ['$resource'];

    function MedDosageUnitSearch($resource) {
        var resourceUrl =  'api/_search/med-dosage-units/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
